import type { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: '31%',
      marginRight: '20px',
      marginBottom: '20px',

      '@media(max-width:992px)': {
        width: '45%',
        marginRight: '20px'
      },

      '@media(max-width:768px)': {
        width: '100%',
        marginRight: 0
      }
    },
    content: {
      height: '100%'
    },
    card: {
      height: '100%'
    },

    actionArea: {
      height: '100%'
    }
  });
export default styles;
